import React, { useState } from "react";
import { LuEye as EyeOpen } from "react-icons/lu";
import { LuEyeOff as EyeClose } from "react-icons/lu";
import PasswordValidationList from "../../PasswordValidationList/PasswordValidationList";

const ChangePassword = ({ passData, onInputChange, errors, editStarted }) => {
  const [showPassWord, setShowPassword] = useState(false);
  const handleShowPassword = () => {
    setShowPassword((currState) => !currState);
  };
  return (
    <div className="profile-password-update-wrapper">
      <div className="form-row">
        <div
          className={`form-group position-relative error-l-75 col-md-12 ${
            editStarted &&
            errors?.new_password1 &&
            errors?.new_password1?.find((validateItem) => validateItem?.isError)
              ? "hasValidationError"
              : ""
          }`}
        >
          <label htmlFor="firstName">
            New Password<i>*</i>
          </label>
          <div className="position-relative">
            <input
              type={showPassWord ? "text" : "password"}
              className="form-control"
              name="new_password1"
              value={passData.new_password1}
              onChange={(e) => onInputChange(e.target)}
              id="new_password1"
              placeholder="Password"
            />
            <span className="input-tail-icon" onClick={handleShowPassword}>
              {showPassWord ? <EyeOpen /> : <EyeClose />}
            </span>
          </div>
          <div className="mt-3  mx-2">
            <PasswordValidationList errorState={errors?.new_password1} />
          </div>
        </div>
      </div>

      <div className="form-row">
        <div
          className={`form-group position-relative error-l-75 col-md-12 ${
            errors?.new_password2 ? "hasValidationError" : ""
          }`}
        >
          <label htmlFor="firstName">
            Confirm Password<i>*</i>
          </label>
          <input
            type="password"
            className="form-control"
            name="new_password2"
            value={passData.new_password2}
            onChange={(e) => onInputChange(e.target)}
            id="new_password2"
            placeholder="Confirm Password"
            onPaste={(e) => e.preventDefault()}
            onDrop={(e) => e.preventDefault()}
            autoComplete="off"
          />
          <p className="error-message">
            {errors && errors?.new_password2 ? errors?.new_password2 : ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
